import { render, staticRenderFns } from "./JoppdADetail.vue?vue&type=template&id=5c1c7b5d"
import script from "./JoppdADetail.vue?vue&type=script&lang=js"
export * from "./JoppdADetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports